import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';

function ConfirmationSummary({ totalQuantity, totalProductCount }) {
	const { t } = useTranslation();

	return (
		<Paper
			elevation={4}
			sx={{
				p: 2,
				borderRadius: 2,
			}}
		>
			<Box
				sx={{ py: 1, display: 'grid', gridTemplateColumns: '1fr auto', gap: 2 }}
			>
				<Typography sx={{ fontSize: '1.15rem' }}>
					{t('new_orders:order_summary:total_quantity')}
				</Typography>
				<Typography align="right" sx={{ fontSize: '1.15rem' }}>
					{totalQuantity}
				</Typography>
			</Box>
			<Box
				sx={{ py: 1, display: 'grid', gridTemplateColumns: '1fr auto', gap: 2 }}
			>
				<Typography sx={{ fontSize: '1.15rem' }}>
					{t('new_orders:order_summary:total_product_count')}
				</Typography>
				<Typography align="right" sx={{ fontSize: '1.15rem' }}>
					{totalProductCount}
				</Typography>
			</Box>
		</Paper>
	);
}

ConfirmationSummary.propTypes = {
	totalQuantity: PropTypes.number.isRequired,
	totalProductCount: PropTypes.number.isRequired,
};

export default React.memo(ConfirmationSummary);
